import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Download, Share, Smartphone } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

const DownloadAppWidget = () => {
  const { settings } = useSettings();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', () => setInstalled(true));
    if (window.matchMedia('(display-mode: standalone)').matches) setInstalled(true);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (settings.show_download_widget === false || installed) return null;

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="px-6 pb-8"
      data-testid="download-app-widget"
    >
      <div className="relative overflow-hidden rounded-3xl p-6 text-white shadow-lg"
        style={{ background: 'linear-gradient(135deg, #065F46 0%, #022C22 100%)' }}>
        <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full" style={{ background: 'rgba(212,175,55,0.18)' }} />
        <div className="relative z-10 flex items-center gap-4">
          {settings.pwa_logo_url ? (
            <img src={settings.pwa_logo_url} alt="App" className="w-14 h-14 rounded-2xl object-cover border border-white/30" />
          ) : (
            <div className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center border border-white/20">
              <Smartphone className="w-7 h-7 text-white" />
            </div>
          )}
          <div className="flex-1">
            <h3 className="text-lg font-heading font-bold leading-tight">
              {settings.download_widget_title || 'Pasang Aplikasi Masjid'}
            </h3>
            <p className="text-white/70 text-xs font-body mt-0.5">
              Akses lebih cepat langsung dari layar utama
            </p>
          </div>
        </div>

        {deferredPrompt ? (
          <button
            data-testid="download-app-install-btn"
            onClick={handleInstall}
            className="relative z-10 mt-5 w-full flex items-center justify-center gap-2 py-3 rounded-full font-body font-semibold text-emerald-900"
            style={{ background: 'linear-gradient(90deg, #FBBF24, #D4AF37)' }}
          >
            <Download className="w-5 h-5" />
            Pasang Sekarang
          </button>
        ) : (
          <div className="relative z-10 mt-5 flex items-start gap-2 bg-white/10 rounded-2xl px-4 py-3 border border-white/15">
            <Share className="w-4 h-4 mt-0.5 shrink-0 text-amber-300" />
            <p className="text-xs font-body text-white/80">
              Buka menu browser, lalu pilih <span className="font-semibold text-white">"Tambahkan ke Layar Utama"</span> untuk memasang aplikasi.
            </p>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default DownloadAppWidget;
